import { useSetState } from '../store/selectors.js';

export const useSetOverlayState = () => {
  const setState = useSetState();

  const setToolbarVisible = (toolbarVisible: boolean) => {
    setState((prev) => {
      return {
        ...prev,
        overlay: {
          toolbarVisible,
        },
      };
    });
  };

  return {
    setToolbarVisible,
  };
};
